document.addEventListener('DOMContentLoaded', function () {
    const initialized = {};

    function initSlick(i) {
        const slider = jQuery(`.product-slider`);
        const isMobile = window.innerWidth < 768;

        if (slider.length) {
            if (isMobile) {
                // if (!slider.hasClass('slick-initialized')) {
                //     slider.slick({
                //         slidesToShow: 1,
                //         slidesToScroll: 1,
                //         arrows: true,
                //         dots: false,
                //         adaptiveHeight: true,
                //     });
                //     initialized[i] = true;
                // } else {
                //     setTimeout(() => {
                //         slider.slick('setPosition');
                //     }, 300);
                // }
            } else {
                if (!slider.hasClass('slick-initialized')) {
                    slider.slick({
                        slidesToShow: 4.3,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                        adaptiveHeight: true,
                        responsive: [
                            { breakpoint: 1024, settings: { slidesToShow: 3 } },
                            { breakpoint: 768, settings: { slidesToShow: 2 } },
                            { breakpoint: 480, settings: { slidesToShow: 1 } }  
                        ]
                    });
                    initialized[i] = true;
                } else {
                    setTimeout(() => {
                        slider.slick('setPosition');
                    }, 300);
                }
            }
        }
    }
    // for (let i = 1; i <= 4; i++) {
    //     initSlick(i);
    // }
    // window.addEventListener('resize', () => {
    //     for (let i = 1; i <= 4; i++) {
    //        initSlick(i);
    //     }
    // });
    initSlick();

    document.querySelectorAll('.tab-btn').forEach(button => {
        button.addEventListener('click', function () {
        document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(tab => tab.classList.remove('active'));

        this.classList.add('active');
        const tabSelector = '.' + this.dataset.tab;
        const activeTab = document.querySelector(tabSelector);
        activeTab.classList.add('active');

        const tabIndex = parseInt(this.dataset.tab.replace('tab-', ''));
        setTimeout(() => initSlick(tabIndex), 200);
        });
    });

    document.addEventListener("click", function (e) {
        const button = e.target.closest(".swatch-button");
        if (!button) return;

        const value = button.dataset.value;
        if (!value) return;

        const wrapper = button.closest("product-card");
        if (!wrapper) return;

        const variantsJson = wrapper.querySelector("[data-variants-json]");
        if (!variantsJson) return;

        const variants = JSON.parse(variantsJson.textContent);
        const variantInput = wrapper.querySelector("input.single-option-selector");
        const productLink = wrapper.querySelector(".product-card-url-link");
        const swatchLabel = wrapper.querySelector(".selected-swatch-label");
        const priceAmount = wrapper.querySelector(".price .final");
        const priceCompare = wrapper.querySelector(".price .compare");
        const imageMapTag = wrapper.querySelector("[data-metal-image-map]");
        const imageMap = imageMapTag ? JSON.parse(imageMapTag.textContent) : {};
        const newImageURL = imageMap[value];

        const allButtons = wrapper.querySelectorAll(`.swatch-button[data-value="${value}"]`);
        wrapper.querySelectorAll(".swatch-button").forEach(btn => btn.classList.remove("selected"));
        allButtons.forEach(btn => btn.classList.add("selected"));

        if (swatchLabel) swatchLabel.textContent = value;

        if (newImageURL) {
        const images = wrapper.querySelectorAll(".main-product-image");
        images.forEach(img => {
            img.src = newImageURL;
        });
        }

        const matched = variants.find(v => v.options[0] === value);
        if (matched) {
        if (variantInput) variantInput.value = matched.id;
        if (productLink) {
            const base = productLink.href.split("?")[0];
            productLink.href = `${base}?variant=${matched.id}`;
        }

        if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
            if (priceAmount) priceAmount.textContent = Shopify.formatMoney(matched.price, Shopify.money_format);
            if (priceCompare) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
                priceCompare.textContent = Shopify.formatMoney(matched.compare_at_price, Shopify.money_format);
                priceCompare.classList.remove("hide");
            } else {
                priceCompare.classList.add("hide");
            }
            }
        } else {
            if (priceAmount) priceAmount.textContent = `$${(matched.price / 100).toFixed(2)}`;
            if (priceCompare) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
                priceCompare.textContent = `$${(matched.compare_at_price / 100).toFixed(2)}`;
                priceCompare.classList.remove("hide");
            } else {
                priceCompare.classList.add("hide");
            }
            }
        }
        }
    });
});